import gql from 'graphql-tag'

import { FRAGMENT_COUNTRY, FRAGMENT_MEDIA, FRAGMENT_PROJECT_CATEGORY, FRAGMENTS_SECTIONS } from './shared.gql'

const FRAGMENT_PROJECT = gql`
  ${FRAGMENT_PROJECT_CATEGORY}
  ${FRAGMENT_COUNTRY}
  ${FRAGMENT_MEDIA}
  ${FRAGMENTS_SECTIONS}

  fragment ProjectDto on Project {
    __typename
    id
    createdAt
    updatedAt
    slug
    title
    intro
    excerpt
    categories {
      ...ProjectCategory
    }
    country {
      ...Country
    }
    image {
      ...Media
    }
    donationHint
    location {
      lat
      lng
    }
    mapBoundsWidth

    sections {
      ...SectionBasic
      ...SectionBoxedText
      ...SectionContact
      ...SectionContentMedia
      ...SectionContentSplit
      ...SectionFilterItems
    }
  }
`

export const QUERY_PROJECT = gql`
  ${FRAGMENT_PROJECT}
  query project($locale: LocaleInputType!, $where: Project_where!, $draft: Boolean!) {
    Projects(locale: $locale, draft: $draft, where: $where, trash: false) {
      docs {
        ...ProjectDto
      }
    }
  }
`
